import React from 'react';
import { JwflLogo } from './EwflLogo';

export const Footer = () => (
  <footer className="ewfl-footer" data-testid="jwfl-footer">
    <div className="flex items-center justify-center gap-3 mb-3 opacity-90">
      <JwflLogo size={34} />
    </div>
    <p className="sig">MADE BY DAVID E</p>
    <p className="sub">JAPAN WORLD FOOTBALL LEAGUE · Season 2026 · 日本</p>
  </footer>
);
